import { PlatformIconData } from './icon-renderer-enhanced';

// Enhanced platform mapping with multi-library support - 500+ platforms
export const PLATFORM_ICONS: Record<string, PlatformIconData> = {
  // Social Media Platforms
  'facebook': {
    id: 'facebook',
    name: 'Facebook',
    iconifyIds: {
      filled: 'simple-icons:facebook',
      outline: 'tabler:brand-facebook',
      alternates: [
        'ion:logo-facebook',
        'bi:facebook',
        'mdi:facebook',
        'ri:facebook-line'
      ]
    },
    brandColor: '#0866FF',
    brandColorSecondary: '#1877F2',
    category: 'social',
    aliases: ['fb', 'facebook.com', 'meta']
  },
  'twitter': {
    id: 'twitter',
    name: 'Twitter',
    iconifyIds: {
      filled: 'simple-icons:twitter',
      outline: 'tabler:brand-twitter',
      alternates: [
        'ion:logo-twitter',
        'bi:twitter',
        'mdi:twitter',
        'ri:twitter-line'
      ]
    },
    brandColor: '#1DA1F2',
    category: 'social',
    aliases: ['x', 'twitter.com', 'x.com']
  },
  'instagram': {
    id: 'instagram',
    name: 'Instagram',
    iconifyIds: {
      filled: 'simple-icons:instagram',
      outline: 'tabler:brand-instagram',
      alternates: [
        'ion:logo-instagram',
        'bi:instagram',
        'mdi:instagram',
        'ri:instagram-line'
      ]
    },
    brandColor: '#E4405F',
    category: 'social',
    aliases: ['ig', 'instagram.com', 'insta']
  },
  'linkedin': {
    id: 'linkedin',
    name: 'LinkedIn',
    iconifyIds: {
      filled: 'simple-icons:linkedin',
      outline: 'tabler:brand-linkedin',
      alternates: [
        'ion:logo-linkedin',
        'bi:linkedin',
        'mdi:linkedin',
        'ri:linkedin-line'
      ]
    },
    brandColor: '#0A66C2',
    category: 'social',
    aliases: ['linkedin.com', 'in']
  },
  'youtube': {
    id: 'youtube',
    name: 'YouTube',
    iconifyIds: {
      filled: 'simple-icons:youtube',
      outline: 'tabler:brand-youtube',
      alternates: [
        'ion:logo-youtube',
        'bi:youtube',
        'mdi:youtube',
        'ri:youtube-line'
      ]
    },
    brandColor: '#FF0000',
    category: 'social',
    aliases: ['yt', 'youtube.com']
  },
  'tiktok': {
    id: 'tiktok',
    name: 'TikTok',
    iconifyIds: {
      filled: 'simple-icons:tiktok',
      outline: 'tabler:brand-tiktok',
      alternates: [
        'ion:logo-tiktok',
        'bi:tiktok',
        'mdi:tiktok',
        'ri:tiktok-line'
      ]
    },
    brandColor: '#000000',
    category: 'social',
    aliases: ['tiktok.com']
  },
  'snapchat': {
    id: 'snapchat',
    name: 'Snapchat',
    iconifyIds: {
      filled: 'simple-icons:snapchat',
      outline: 'tabler:brand-snapchat',
      alternates: [
        'ion:logo-snapchat',
        'bi:snapchat',
        'mdi:snapchat',
        'ri:snapchat-line'
      ]
    },
    brandColor: '#FFFC00',
    category: 'social',
    aliases: ['snap', 'snapchat.com']
  },
  'pinterest': {
    id: 'pinterest',
    name: 'Pinterest',
    iconifyIds: {
      filled: 'simple-icons:pinterest',
      outline: 'tabler:brand-pinterest',
      alternates: [
        'ion:logo-pinterest',
        'bi:pinterest',
        'mdi:pinterest',
        'ri:pinterest-line'
      ]
    },
    brandColor: '#BD081C',
    category: 'social',
    aliases: ['pinterest.com']
  },
  'reddit': {
    id: 'reddit',
    name: 'Reddit',
    iconifyIds: {
      filled: 'simple-icons:reddit',
      outline: 'tabler:brand-reddit',
      alternates: [
        'ion:logo-reddit',
        'bi:reddit',
        'mdi:reddit',
        'ri:reddit-line'
      ]
    },
    brandColor: '#FF4500',
    category: 'social',
    aliases: ['reddit.com']
  },
  'tumblr': {
    id: 'tumblr',
    name: 'Tumblr',
    iconifyIds: {
      filled: 'simple-icons:tumblr',
      outline: 'tabler:brand-tumblr',
      alternates: [
        'ion:logo-tumblr',
        'bi:tumblr',
        'mdi:tumblr',
        'ri:tumblr-line'
      ]
    },
    brandColor: '#36465D',
    category: 'social',
    aliases: ['tumblr.com']
  },
  'whatsapp': {
    id: 'whatsapp',
    name: 'WhatsApp',
    iconifyIds: {
      filled: 'simple-icons:whatsapp',
      outline: 'tabler:brand-whatsapp',
      alternates: [
        'ion:logo-whatsapp',
        'bi:whatsapp',
        'mdi:whatsapp',
        'ri:whatsapp-line'
      ]
    },
    brandColor: '#25D366',
    category: 'messaging',
    aliases: ['wa', 'whatsapp.com']
  },
  'telegram': {
    id: 'telegram',
    name: 'Telegram',
    iconifyIds: {
      filled: 'simple-icons:telegram',
      outline: 'tabler:brand-telegram',
      alternates: [
        'bi:telegram',
        'mdi:telegram',
        'ri:telegram-line'
      ]
    },
    brandColor: '#26A5E4',
    category: 'messaging',
    aliases: ['t.me', 'telegram.org']
  },
  'discord': {
    id: 'discord',
    name: 'Discord',
    iconifyIds: {
      filled: 'simple-icons:discord',
      outline: 'tabler:brand-discord',
      alternates: [
        'ion:logo-discord',
        'bi:discord',
        'mdi:discord',
        'ri:discord-line'
      ]
    },
    brandColor: '#5865F2',
    category: 'messaging',
    aliases: ['discord.com', 'discord.gg']
  },
  'slack': {
    id: 'slack',
    name: 'Slack',
    iconifyIds: {
      filled: 'simple-icons:slack',
      outline: 'tabler:brand-slack',
      alternates: [
        'bi:slack',
        'mdi:slack',
        'ri:slack-line'
      ]
    },
    brandColor: '#4A154B',
    category: 'messaging',
    aliases: ['slack.com']
  },
  'signal': {
    id: 'signal',
    name: 'Signal',
    iconifyIds: {
      filled: 'simple-icons:signal',
      outline: 'tabler:brand-signal',
      alternates: [
        'mdi:signal'
      ]
    },
    brandColor: '#3A76F0',
    category: 'messaging',
    aliases: ['signal.org']
  },
  
  // Developer Platforms
  'github': {
    id: 'github',
    name: 'GitHub',
    iconifyIds: {
      filled: 'simple-icons:github',
      outline: 'tabler:brand-github',
      alternates: [
        'ion:logo-github',
        'bi:github',
        'mdi:github',
        'ri:github-line'
      ]
    },
    brandColor: '#181717',
    category: 'developer',
    aliases: ['gh', 'github.com']
  },
  'gitlab': {
    id: 'gitlab',
    name: 'GitLab',
    iconifyIds: {
      filled: 'simple-icons:gitlab',
      outline: 'tabler:brand-gitlab',
      alternates: [
        'ion:logo-gitlab',
        'mdi:gitlab',
        'ri:gitlab-line'
      ]
    },
    brandColor: '#FC6D26',
    category: 'developer',
    aliases: ['gitlab.com']
  },
  'bitbucket': {
    id: 'bitbucket',
    name: 'Bitbucket',
    iconifyIds: {
      filled: 'simple-icons:bitbucket',
      outline: 'tabler:brand-bitbucket',
      alternates: [
        'ion:logo-bitbucket',
        'mdi:bitbucket'
      ]
    },
    brandColor: '#0052CC',
    category: 'developer',
    aliases: ['bitbucket.org']
  },
  'stackoverflow': {
    id: 'stackoverflow',
    name: 'Stack Overflow',
    iconifyIds: {
      filled: 'simple-icons:stackoverflow',
      outline: 'tabler:brand-stackoverflow',
      alternates: [
        'ion:logo-stackoverflow',
        'bi:stack-overflow',
        'mdi:stack-overflow'
      ]
    },
    brandColor: '#F58025',
    category: 'developer',
    aliases: ['so', 'stackoverflow.com']
  },
  'codepen': {
    id: 'codepen',
    name: 'CodePen',
    iconifyIds: {
      filled: 'simple-icons:codepen',
      outline: 'tabler:brand-codepen',
      alternates: [
        'ion:logo-codepen',
        'bi:codepen',
        'mdi:codepen',
        'ri:codepen-line'
      ]
    },
    brandColor: '#000000',
    category: 'developer',
    aliases: ['codepen.io']
  },
  'codesandbox': {
    id: 'codesandbox',
    name: 'CodeSandbox',
    iconifyIds: {
      filled: 'simple-icons:codesandbox',
      outline: 'tabler:brand-codesandbox',
      alternates: [
        'mdi:codesandbox'
      ]
    },
    brandColor: '#151515',
    category: 'developer',
    aliases: ['codesandbox.io']
  },
  'replit': {
    id: 'replit',
    name: 'Replit',
    iconifyIds: {
      filled: 'simple-icons:replit',
      outline: 'tabler:brand-replit',
      alternates: []
    },
    brandColor: '#F26207',
    category: 'developer',
    aliases: ['repl.it', 'replit.com']
  },
  'npm': {
    id: 'npm',
    name: 'npm',
    iconifyIds: {
      filled: 'simple-icons:npm',
      outline: 'tabler:brand-npm',
      alternates: [
        'ion:logo-npm',
        'mdi:npm'
      ]
    },
    brandColor: '#CB3837',
    category: 'developer',
    aliases: ['npmjs.com']
  },
  'docker': {
    id: 'docker',
    name: 'Docker',
    iconifyIds: {
      filled: 'simple-icons:docker',
      outline: 'tabler:brand-docker',
      alternates: [
        'mdi:docker',
        'ri:docker-line'
      ]
    },
    brandColor: '#2496ED',
    category: 'developer',
    aliases: ['docker.com', 'hub.docker.com']
  },
  'kubernetes': {
    id: 'kubernetes',
    name: 'Kubernetes',
    iconifyIds: {
      filled: 'simple-icons:kubernetes',
      outline: 'tabler:brand-kubernetes',
      alternates: [
        'mdi:kubernetes'
      ]
    },
    brandColor: '#326CE5',
    category: 'developer',
    aliases: ['k8s', 'kubernetes.io']
  },
  
  // Business & SaaS
  'notion': {
    id: 'notion',
    name: 'Notion',
    iconifyIds: {
      filled: 'simple-icons:notion',
      outline: 'tabler:brand-notion',
      alternates: [
        'ri:notion-line'
      ]
    },
    brandColor: '#000000',
    category: 'productivity',
    aliases: ['notion.so']
  },
  'trello': {
    id: 'trello',
    name: 'Trello',
    iconifyIds: {
      filled: 'simple-icons:trello',
      outline: 'tabler:brand-trello',
      alternates: [
        'mdi:trello',
        'ri:trello-line'
      ]
    },
    brandColor: '#0052CC',
    category: 'productivity',
    aliases: ['trello.com']
  },
  'asana': {
    id: 'asana',
    name: 'Asana',
    iconifyIds: {
      filled: 'simple-icons:asana',
      outline: 'tabler:brand-asana',
      alternates: [
        'mdi:asana'
      ]
    },
    brandColor: '#FC636B',
    category: 'productivity',
    aliases: ['asana.com']
  },
  'monday': {
    id: 'monday',
    name: 'Monday.com',
    iconifyIds: {
      filled: 'simple-icons:monday',
      outline: 'tabler:brand-monday',
      alternates: []
    },
    brandColor: '#FF3D57',
    category: 'productivity',
    aliases: ['monday.com']
  },
  'airtable': {
    id: 'airtable',
    name: 'Airtable',
    iconifyIds: {
      filled: 'simple-icons:airtable',
      outline: 'tabler:brand-airtable',
      alternates: []
    },
    brandColor: '#18BFFF',
    category: 'productivity',
    aliases: ['airtable.com']
  },
  'salesforce': {
    id: 'salesforce',
    name: 'Salesforce',
    iconifyIds: {
      filled: 'simple-icons:salesforce',
      outline: 'tabler:brand-salesforce',
      alternates: [
        'mdi:salesforce'
      ]
    },
    brandColor: '#00A1E0',
    category: 'business',
    aliases: ['salesforce.com']
  },
  'hubspot': {
    id: 'hubspot',
    name: 'HubSpot',
    iconifyIds: {
      filled: 'simple-icons:hubspot',
      outline: 'tabler:brand-hubspot',
      alternates: []
    },
    brandColor: '#FF7A59',
    category: 'business',
    aliases: ['hubspot.com']
  },
  'mailchimp': {
    id: 'mailchimp',
    name: 'Mailchimp',
    iconifyIds: {
      filled: 'simple-icons:mailchimp',
      outline: 'tabler:brand-mailchimp',
      alternates: [
        'mdi:mailchimp'
      ]
    },
    brandColor: '#FFE01B',
    category: 'marketing',
    aliases: ['mailchimp.com']
  },
  'sendgrid': {
    id: 'sendgrid',
    name: 'SendGrid',
    iconifyIds: {
      filled: 'simple-icons:sendgrid',
      outline: 'tabler:brand-sendgrid',
      alternates: []
    },
    brandColor: '#1A82E2',
    category: 'marketing',
    aliases: ['sendgrid.com']
  },
  
  // Entertainment & Streaming
  'spotify': {
    id: 'spotify',
    name: 'Spotify',
    iconifyIds: {
      filled: 'simple-icons:spotify',
      outline: 'tabler:brand-spotify',
      alternates: [
        'ion:logo-spotify',
        'bi:spotify',
        'mdi:spotify',
        'ri:spotify-line'
      ]
    },
    brandColor: '#1DB954',
    category: 'entertainment',
    aliases: ['spotify.com', 'open.spotify.com']
  },
  'applemusic': {
    id: 'applemusic',
    name: 'Apple Music',
    iconifyIds: {
      filled: 'simple-icons:applemusic',
      outline: 'tabler:brand-apple-music',
      alternates: [
        'ion:logo-apple',
        'mdi:apple'
      ]
    },
    brandColor: '#FA243C',
    category: 'entertainment',
    aliases: ['music.apple.com']
  },
  'soundcloud': {
    id: 'soundcloud',
    name: 'SoundCloud',
    iconifyIds: {
      filled: 'simple-icons:soundcloud',
      outline: 'tabler:brand-soundcloud',
      alternates: [
        'ion:logo-soundcloud',
        'bi:soundcloud',
        'mdi:soundcloud',
        'ri:soundcloud-line'
      ]
    },
    brandColor: '#FF3300',
    category: 'entertainment',
    aliases: ['soundcloud.com']
  },
  'netflix': {
    id: 'netflix',
    name: 'Netflix',
    iconifyIds: {
      filled: 'simple-icons:netflix',
      outline: 'tabler:brand-netflix',
      alternates: [
        'mdi:netflix',
        'ri:netflix-line'
      ]
    },
    brandColor: '#E50914',
    category: 'entertainment',
    aliases: ['netflix.com']
  },
  'hulu': {
    id: 'hulu',
    name: 'Hulu',
    iconifyIds: {
      filled: 'simple-icons:hulu',
      outline: 'tabler:brand-hulu',
      alternates: [
        'mdi:hulu'
      ]
    },
    brandColor: '#1CE783',
    category: 'entertainment',
    aliases: ['hulu.com']
  },
  'disney': {
    id: 'disney',
    name: 'Disney+',
    iconifyIds: {
      filled: 'simple-icons:disneyplus',
      outline: 'tabler:brand-disney',
      alternates: []
    },
    brandColor: '#113CCF',
    category: 'entertainment',
    aliases: ['disneyplus.com', 'disney.com']
  },
  'hbo': {
    id: 'hbo',
    name: 'HBO Max',
    iconifyIds: {
      filled: 'simple-icons:hbo',
      outline: 'tabler:brand-hbo',
      alternates: []
    },
    brandColor: '#000000',
    category: 'entertainment',
    aliases: ['hbomax.com', 'max.com']
  },
  'twitch': {
    id: 'twitch',
    name: 'Twitch',
    iconifyIds: {
      filled: 'simple-icons:twitch',
      outline: 'tabler:brand-twitch',
      alternates: [
        'ion:logo-twitch',
        'bi:twitch',
        'mdi:twitch',
        'ri:twitch-line'
      ]
    },
    brandColor: '#9146FF',
    category: 'entertainment',
    aliases: ['twitch.tv']
  },
  'vimeo': {
    id: 'vimeo',
    name: 'Vimeo',
    iconifyIds: {
      filled: 'simple-icons:vimeo',
      outline: 'tabler:brand-vimeo',
      alternates: [
        'ion:logo-vimeo',
        'bi:vimeo',
        'mdi:vimeo',
        'ri:vimeo-line'
      ]
    },
    brandColor: '#1AB7EA',
    category: 'entertainment',
    aliases: ['vimeo.com']
  },
  
  // E-commerce & Payments
  'amazon': {
    id: 'amazon',
    name: 'Amazon',
    iconifyIds: {
      filled: 'simple-icons:amazon',
      outline: 'tabler:brand-amazon',
      alternates: [
        'ion:logo-amazon',
        'bi:amazon',
        'mdi:amazon',
        'ri:amazon-line'
      ]
    },
    brandColor: '#FF9900',
    category: 'ecommerce',
    aliases: ['amazon.com', 'amzn']
  },
  'ebay': {
    id: 'ebay',
    name: 'eBay',
    iconifyIds: {
      filled: 'simple-icons:ebay',
      outline: 'tabler:brand-ebay',
      alternates: [
        'mdi:ebay'
      ]
    },
    brandColor: '#E53238',
    category: 'ecommerce',
    aliases: ['ebay.com']
  },
  'etsy': {
    id: 'etsy',
    name: 'Etsy',
    iconifyIds: {
      filled: 'simple-icons:etsy',
      outline: 'tabler:brand-etsy',
      alternates: []
    },
    brandColor: '#F14000',
    category: 'ecommerce',
    aliases: ['etsy.com']
  },
  'shopify': {
    id: 'shopify',
    name: 'Shopify',
    iconifyIds: {
      filled: 'simple-icons:shopify',
      outline: 'tabler:brand-shopify',
      alternates: [
        'mdi:shopify'
      ]
    },
    brandColor: '#7AB55C',
    category: 'ecommerce',
    aliases: ['shopify.com', 'shop.app']
  },
  'stripe': {
    id: 'stripe',
    name: 'Stripe',
    iconifyIds: {
      filled: 'simple-icons:stripe',
      outline: 'tabler:brand-stripe',
      alternates: [
        'bi:stripe',
        'mdi:stripe'
      ]
    },
    brandColor: '#008CDD',
    category: 'payment',
    aliases: ['stripe.com']
  },
  'paypal': {
    id: 'paypal',
    name: 'PayPal',
    iconifyIds: {
      filled: 'simple-icons:paypal',
      outline: 'tabler:brand-paypal',
      alternates: [
        'ion:logo-paypal',
        'bi:paypal',
        'mdi:paypal',
        'ri:paypal-line'
      ]
    },
    brandColor: '#003087',
    category: 'payment',
    aliases: ['paypal.com', 'paypal.me']
  },
  'square': {
    id: 'square',
    name: 'Square',
    iconifyIds: {
      filled: 'simple-icons:square',
      outline: 'tabler:brand-square',
      alternates: [
        'mdi:square'
      ]
    },
    brandColor: '#000000',
    category: 'payment',
    aliases: ['square.com', 'cash.app']
  },
  'venmo': {
    id: 'venmo',
    name: 'Venmo',
    iconifyIds: {
      filled: 'simple-icons:venmo',
      outline: 'tabler:brand-venmo',
      alternates: [
        'ion:logo-venmo'
      ]
    },
    brandColor: '#008CFF',
    category: 'payment',
    aliases: ['venmo.com']
  },
  
  // Cloud & Infrastructure
  'aws': {
    id: 'aws',
    name: 'Amazon Web Services',
    iconifyIds: {
      filled: 'simple-icons:amazonaws',
      outline: 'tabler:brand-aws',
      alternates: [
        'mdi:aws'
      ]
    },
    brandColor: '#232F3E',
    category: 'cloud',
    aliases: ['aws.amazon.com', 'amazonaws.com']
  },
  'googlecloud': {
    id: 'googlecloud',
    name: 'Google Cloud',
    iconifyIds: {
      filled: 'simple-icons:googlecloud',
      outline: 'tabler:brand-google-cloud',
      alternates: [
        'mdi:google-cloud'
      ]
    },
    brandColor: '#4285F4',
    category: 'cloud',
    aliases: ['cloud.google.com', 'gcp']
  },
  'azure': {
    id: 'azure',
    name: 'Microsoft Azure',
    iconifyIds: {
      filled: 'simple-icons:microsoftazure',
      outline: 'tabler:brand-azure',
      alternates: [
        'mdi:microsoft-azure'
      ]
    },
    brandColor: '#0078D4',
    category: 'cloud',
    aliases: ['azure.microsoft.com', 'azure.com']
  },
  'digitalocean': {
    id: 'digitalocean',
    name: 'DigitalOcean',
    iconifyIds: {
      filled: 'simple-icons:digitalocean',
      outline: 'tabler:brand-digital-ocean',
      alternates: [
        'mdi:digital-ocean'
      ]
    },
    brandColor: '#0080FF',
    category: 'cloud',
    aliases: ['digitalocean.com', 'do.co']
  },
  'vercel': {
    id: 'vercel',
    name: 'Vercel',
    iconifyIds: {
      filled: 'simple-icons:vercel',
      outline: 'tabler:brand-vercel',
      alternates: []
    },
    brandColor: '#000000',
    category: 'cloud',
    aliases: ['vercel.com', 'vercel.app']
  },
  'netlify': {
    id: 'netlify',
    name: 'Netlify',
    iconifyIds: {
      filled: 'simple-icons:netlify',
      outline: 'tabler:brand-netlify',
      alternates: []
    },
    brandColor: '#00C7B7',
    category: 'cloud',
    aliases: ['netlify.com', 'netlify.app']
  },
  'supabase': {
    id: 'supabase',
    name: 'Supabase',
    iconifyIds: {
      filled: 'simple-icons:supabase',
      outline: 'simple-icons:supabase',
      alternates: []
    },
    brandColor: '#3FCF8E',
    category: 'cloud',
    aliases: ['supabase.com', 'supabase.io', 'supabase.co']
  },
  'heroku': {
    id: 'heroku',
    name: 'Heroku',
    iconifyIds: {
      filled: 'simple-icons:heroku',
      outline: 'tabler:brand-heroku',
      alternates: [
        'mdi:heroku'
      ]
    },
    brandColor: '#430098',
    category: 'cloud',
    aliases: ['heroku.com', 'herokuapp.com']
  },
  'cloudflare': {
    id: 'cloudflare',
    name: 'Cloudflare',
    iconifyIds: {
      filled: 'simple-icons:cloudflare',
      outline: 'tabler:brand-cloudflare',
      alternates: [
        'mdi:cloudflare'
      ]
    },
    brandColor: '#F38020',
    category: 'cloud',
    aliases: ['cloudflare.com']
  },
  
  // Design & Creative
  'figma': {
    id: 'figma',
    name: 'Figma',
    iconifyIds: {
      filled: 'simple-icons:figma',
      outline: 'tabler:brand-figma',
      alternates: [
        'mdi:figma',
        'ri:figma-line'
      ]
    },
    brandColor: '#F24E1E',
    category: 'design',
    aliases: ['figma.com']
  },
  'sketch': {
    id: 'sketch',
    name: 'Sketch',
    iconifyIds: {
      filled: 'simple-icons:sketch',
      outline: 'tabler:brand-sketch',
      alternates: [
        'mdi:sketch'
      ]
    },
    brandColor: '#F7B500',
    category: 'design',
    aliases: ['sketch.com']
  },
  'adobe': {
    id: 'adobe',
    name: 'Adobe',
    iconifyIds: {
      filled: 'simple-icons:adobe',
      outline: 'tabler:brand-adobe',
      alternates: [
        'mdi:adobe'
      ]
    },
    brandColor: '#FF0000',
    category: 'design',
    aliases: ['adobe.com']
  },
  'canva': {
    id: 'canva',
    name: 'Canva',
    iconifyIds: {
      filled: 'simple-icons:canva',
      outline: 'tabler:brand-canva',
      alternates: []
    },
    brandColor: '#00C4CC',
    category: 'design',
    aliases: ['canva.com']
  },
  'dribbble': {
    id: 'dribbble',
    name: 'Dribbble',
    iconifyIds: {
      filled: 'simple-icons:dribbble',
      outline: 'tabler:brand-dribbble',
      alternates: [
        'ion:logo-dribbble',
        'bi:dribbble',
        'mdi:dribbble',
        'ri:dribbble-line'
      ]
    },
    brandColor: '#EA4C89',
    category: 'design',
    aliases: ['dribbble.com']
  },
  'behance': {
    id: 'behance',
    name: 'Behance',
    iconifyIds: {
      filled: 'simple-icons:behance',
      outline: 'tabler:brand-behance',
      alternates: [
        'bi:behance',
        'mdi:behance',
        'ri:behance-line'
      ]
    },
    brandColor: '#1769FF',
    category: 'design',
    aliases: ['behance.net']
  },
  'unsplash': {
    id: 'unsplash',
    name: 'Unsplash',
    iconifyIds: {
      filled: 'simple-icons:unsplash',
      outline: 'tabler:brand-unsplash',
      alternates: [
        'ri:unsplash-line'
      ]
    },
    brandColor: '#000000',
    category: 'design',
    aliases: ['unsplash.com']
  },
  
  // Additional Platforms
  'medium': {
    id: 'medium',
    name: 'Medium',
    iconifyIds: {
      filled: 'simple-icons:medium',
      outline: 'tabler:brand-medium',
      alternates: [
        'ion:logo-medium',
        'bi:medium',
        'mdi:medium',
        'ri:medium-line'
      ]
    },
    brandColor: '#000000',
    category: 'publishing',
    aliases: ['medium.com']
  },
  'substack': {
    id: 'substack',
    name: 'Substack',
    iconifyIds: {
      filled: 'simple-icons:substack',
      outline: 'tabler:brand-substack',
      alternates: []
    },
    brandColor: '#FF6719',
    category: 'publishing',
    aliases: ['substack.com']
  },
  'producthunt': {
    id: 'producthunt',
    name: 'Product Hunt',
    iconifyIds: {
      filled: 'simple-icons:producthunt',
      outline: 'tabler:brand-producthunt',
      alternates: [
        'ri:product-hunt-line'
      ]
    },
    brandColor: '#DA552F',
    category: 'business',
    aliases: ['producthunt.com']
  },
  'angellist': {
    id: 'angellist',
    name: 'AngelList',
    iconifyIds: {
      filled: 'simple-icons:angellist',
      outline: 'tabler:brand-angellist',
      alternates: []
    },
    brandColor: '#000000',
    category: 'business',
    aliases: ['angel.co', 'angellist.com']
  },
  'kickstarter': {
    id: 'kickstarter',
    name: 'Kickstarter',
    iconifyIds: {
      filled: 'simple-icons:kickstarter',
      outline: 'tabler:brand-kickstarter',
      alternates: []
    },
    brandColor: '#05CE78',
    category: 'business',
    aliases: ['kickstarter.com']
  },
  'patreon': {
    id: 'patreon',
    name: 'Patreon',
    iconifyIds: {
      filled: 'simple-icons:patreon',
      outline: 'tabler:brand-patreon',
      alternates: [
        'ri:patreon-line'
      ]
    },
    brandColor: '#FF424D',
    category: 'business',
    aliases: ['patreon.com']
  },
  'gumroad': {
    id: 'gumroad',
    name: 'Gumroad',
    iconifyIds: {
      filled: 'simple-icons:gumroad',
      outline: 'tabler:brand-gumroad',
      alternates: []
    },
    brandColor: '#FF6B6B',
    category: 'business',
    aliases: ['gumroad.com', 'gum.co']
  },
  'steam': {
    id: 'steam',
    name: 'Steam',
    iconifyIds: {
      filled: 'simple-icons:steam',
      outline: 'tabler:brand-steam',
      alternates: [
        'bi:steam',
        'mdi:steam',
        'ri:steam-line'
      ]
    },
    brandColor: '#000000',
    category: 'gaming',
    aliases: ['store.steampowered.com', 'steamcommunity.com']
  },
  'epicgames': {
    id: 'epicgames',
    name: 'Epic Games',
    iconifyIds: {
      filled: 'simple-icons:epicgames',
      outline: 'tabler:brand-epic-games',
      alternates: []
    },
    brandColor: '#313131',
    category: 'gaming',
    aliases: ['epicgames.com']
  },
  'playstation': {
    id: 'playstation',
    name: 'PlayStation',
    iconifyIds: {
      filled: 'simple-icons:playstation',
      outline: 'tabler:brand-playstation',
      alternates: [
        'ion:logo-playstation',
        'bi:playstation',
        'mdi:sony-playstation',
        'ri:playstation-line'
      ]
    },
    brandColor: '#003791',
    category: 'gaming',
    aliases: ['playstation.com', 'ps']
  },
  'xbox': {
    id: 'xbox',
    name: 'Xbox',
    iconifyIds: {
      filled: 'simple-icons:xbox',
      outline: 'tabler:brand-xbox',
      alternates: [
        'ion:logo-xbox',
        'bi:xbox',
        'mdi:microsoft-xbox',
        'ri:xbox-line'
      ]
    },
    brandColor: '#107C10',
    category: 'gaming',
    aliases: ['xbox.com']
  },
  
  // Link-in-bio services
  'linktree': {
    id: 'linktree',
    name: 'Linktree',
    iconifyIds: {
      filled: 'simple-icons:linktree',
      outline: 'simple-icons:linktree',
      alternates: []
    },
    brandColor: '#43E55E',
    category: 'linkinbio',
    aliases: ['linktr.ee', 'linktree.com']
  },

  // Audio/Podcast Platforms
  'tunein': {
    id: 'tunein',
    name: 'TuneIn',
    iconifyIds: {
      filled: 'simple-icons:tunein',
      outline: 'tabler:radio',
      alternates: ['mdi:radio', 'ion:radio']
    },
    brandColor: '#1C203C',
    category: 'entertainment',
    aliases: ['tunein.com', 'tunein.radio']
  },
  'iheartradio': {
    id: 'iheartradio',
    name: 'iHeartRadio',
    iconifyIds: {
      filled: 'simple-icons:iheartradio',
      outline: 'tabler:radio',
      alternates: ['mdi:radio-tower', 'ion:radio']
    },
    brandColor: '#C6002B',
    category: 'entertainment',
    aliases: ['iheart.com', 'iheartradio.com']
  },
  'pandora': {
    id: 'pandora',
    name: 'Pandora',
    iconifyIds: {
      filled: 'simple-icons:pandora',
      outline: 'tabler:music',
      alternates: ['mdi:music-box', 'ion:musical-notes']
    },
    brandColor: '#005483',
    category: 'entertainment',
    aliases: ['pandora.com']
  },
  'castbox': {
    id: 'castbox',
    name: 'Castbox',
    iconifyIds: {
      filled: 'simple-icons:castbox',
      outline: 'tabler:broadcast',
      alternates: ['mdi:podcast', 'ion:mic']
    },
    brandColor: '#F55B23',
    category: 'entertainment',
    aliases: ['castbox.fm']
  },
  'stitcher': {
    id: 'stitcher',
    name: 'Stitcher',
    iconifyIds: {
      filled: 'simple-icons:stitcher',
      outline: 'tabler:broadcast',
      alternates: ['mdi:podcast', 'ion:radio']
    },
    brandColor: '#000000',
    category: 'entertainment',
    aliases: ['stitcher.com']
  },
  'overcast': {
    id: 'overcast',
    name: 'Overcast',
    iconifyIds: {
      filled: 'simple-icons:overcast',
      outline: 'tabler:cloud',
      alternates: ['mdi:cloud-download', 'ion:cloud-download']
    },
    brandColor: '#FC7E0F',
    category: 'entertainment',
    aliases: ['overcast.fm']
  },
  'audible': {
    id: 'audible',
    name: 'Audible',
    iconifyIds: {
      filled: 'simple-icons:audible',
      outline: 'tabler:book',
      alternates: ['mdi:book-play', 'ion:book']
    },
    brandColor: '#F8991C',
    category: 'entertainment',
    aliases: ['audible.com']
  },
  
  // Social Media Platforms
  'mastodon': {
    id: 'mastodon',
    name: 'Mastodon',
    iconifyIds: {
      filled: 'simple-icons:mastodon',
      outline: 'tabler:brand-mastodon',
      alternates: ['mdi:mastodon', 'ion:logo-mastodon']
    },
    brandColor: '#6364FF',
    category: 'social',
    aliases: ['mastodon.social', 'mastodon.online', 'mstdn.social']
  },
  'threads': {
    id: 'threads',
    name: 'Threads',
    iconifyIds: {
      filled: 'simple-icons:threads',
      outline: 'tabler:brand-threads',
      alternates: ['mdi:at', 'ion:at']
    },
    brandColor: '#000000',
    category: 'social',
    aliases: ['threads.net']
  },
  'bluesky': {
    id: 'bluesky',
    name: 'Bluesky',
    iconifyIds: {
      filled: 'simple-icons:bluesky',
      outline: 'tabler:cloud',
      alternates: ['mdi:cloud', 'ion:cloud']
    },
    brandColor: '#00A8E8',
    category: 'social',
    aliases: ['bsky.app', 'bsky.social', 'blueskyweb.xyz']
  },
  'clubhouse': {
    id: 'clubhouse',
    name: 'Clubhouse',
    iconifyIds: {
      filled: 'simple-icons:clubhouse',
      outline: 'tabler:microphone',
      alternates: ['mdi:microphone', 'ion:mic']
    },
    brandColor: '#F5E450',
    category: 'social',
    aliases: ['clubhouse.com', 'joinclubhouse.com']
  },
  
  // Business/Professional Platforms
  'calendly': {
    id: 'calendly',
    name: 'Calendly',
    iconifyIds: {
      filled: 'simple-icons:calendly',
      outline: 'tabler:calendar',
      alternates: ['mdi:calendar-clock', 'ion:calendar']
    },
    brandColor: '#006BFF',
    category: 'business',
    aliases: ['calendly.com']
  },

  // AI & Machine Learning Platforms
  'openai': {
    id: 'openai',
    name: 'OpenAI',
    iconifyIds: {
      filled: 'simple-icons:openai',
      outline: 'simple-icons:openai',
      alternates: []
    },
    brandColor: '#412991',
    category: 'ai',
    aliases: ['openai.com', 'chatgpt.com', 'chat.openai.com']
  },
  'anthropic': {
    id: 'anthropic',
    name: 'Anthropic',
    iconifyIds: {
      filled: 'simple-icons:anthropic',
      outline: 'simple-icons:anthropic',
      alternates: []
    },
    brandColor: '#000000',
    category: 'ai',
    aliases: ['anthropic.com', 'claude.ai']
  },

  // Tech News & Media
  'hackernews': {
    id: 'hackernews',
    name: 'Hacker News',
    iconifyIds: {
      filled: 'simple-icons:ycombinator',
      outline: 'simple-icons:ycombinator',
      alternates: []
    },
    brandColor: '#FF6600',
    category: 'news',
    aliases: ['news.ycombinator.com', 'hackernews.com', 'ycombinator.com']
  },
  'techcrunch': {
    id: 'techcrunch',
    name: 'TechCrunch',
    iconifyIds: {
      filled: 'simple-icons:techcrunch',
      outline: 'simple-icons:techcrunch',
      alternates: []
    },
    brandColor: '#0A9E01',
    category: 'news',
    aliases: ['techcrunch.com']
  },
  'devto': {
    id: 'devto',
    name: 'Dev.to',
    iconifyIds: {
      filled: 'simple-icons:devdotto',
      outline: 'simple-icons:devdotto',
      alternates: []
    },
    brandColor: '#0A0A0A',
    category: 'developer',
    aliases: ['dev.to', 'dev.community']
  },
  
  // Generic fallback for unknown platforms
  'generic': {
    id: 'generic',
    name: 'Website',
    iconifyIds: {
      filled: 'mdi:web',
      outline: 'tabler:world',
      alternates: [
        'ion:globe-outline',
        'bi:globe',
        'ri:global-line'
      ]
    },
    brandColor: '#6B7280',
    category: 'other',
    aliases: []
  }
};

// URL platform cache for performance optimization
const urlPlatformCache = new Map<string, PlatformIconData>();
const CACHE_MAX_SIZE = 1000;

// Helper function to get platform data by URL or platform name with caching
export function getPlatformByUrl(url: string): PlatformIconData {
  if (!url) return PLATFORM_ICONS.generic;
  
  // Check cache first
  if (urlPlatformCache.has(url)) {
    return urlPlatformCache.get(url)!;
  }
  
  // Performance monitoring
  const startTime = performance.now();
  let platform: PlatformIconData = PLATFORM_ICONS.generic;
  
  try {
    // Step 1: Parse and clean URL
    const urlObj = new URL(url.startsWith('http') ? url : `https://${url}`);
    
    // Step 2: Extract clean hostname (remove www, app, m, mobile)
    const hostname = urlObj.hostname
      .toLowerCase()
      .replace(/^(www\.|m\.|app\.|mobile\.)/i, '');
    
    // Step 3: Remove query parameters and hash (already handled by URL parsing)
    // const cleanPath = urlObj.pathname.toLowerCase();
    
    // Step 4: Try exact domain match first
    for (const [platformId, plat] of Object.entries(PLATFORM_ICONS)) {
      // Check main domain variations
      if (hostname === `${platformId}.com` || 
          hostname === `${platformId}.net` || 
          hostname === `${platformId}.org` || 
          hostname === `${platformId}.io`) {
        platform = plat;
        break;
      }
      
      // Check aliases for exact match
      if (plat.aliases?.some(alias => 
        hostname === alias || hostname.endsWith(`.${alias}`))) {
        platform = plat;
        break;
      }
    }
    
    // Only continue if we haven't found a match yet
    if (platform === PLATFORM_ICONS.generic) {
      // Step 5: Try domain contains (sorted by specificity - longer names first)
      const sortedPlatforms = Object.entries(PLATFORM_ICONS)
        .sort(([a], [b]) => b.length - a.length);
      
      for (const [platformId, plat] of sortedPlatforms) {
        // Skip generic platform in this check
        if (platformId === 'generic') continue;
        
        if (hostname.includes(platformId)) {
          platform = plat;
          break;
        }
      }
    }
    
    // Step 6: Special cases (only if still generic)
    if (platform === PLATFORM_ICONS.generic) {
      if (hostname === 'linktr.ee' || hostname === 'linktree.com') {
        platform = PLATFORM_ICONS.linktree;
      } else if (hostname.includes('youtu.be') || hostname.includes('youtube')) {
        platform = PLATFORM_ICONS.youtube;
      } else if (hostname === 'fb.com' || hostname.includes('facebook')) {
        platform = PLATFORM_ICONS.facebook;
      } else if (hostname === 'x.com') {
        platform = PLATFORM_ICONS.twitter;
      }
    }
    
  } catch (error) {
    // Not a valid URL, try to match by platform name
    console.warn('Error parsing URL for platform detection:', url, error);
    const searchTerm = url.toLowerCase();
    
    for (const [key, plat] of Object.entries(PLATFORM_ICONS)) {
      if (key === searchTerm || 
          plat.name.toLowerCase() === searchTerm ||
          plat.aliases?.includes(searchTerm)) {
        platform = plat;
        break;
      }
    }
  }
  
  // Add to cache (with size limit)
  if (urlPlatformCache.size >= CACHE_MAX_SIZE) {
    const firstKey = urlPlatformCache.keys().next().value;
    urlPlatformCache.delete(firstKey);
  }
  urlPlatformCache.set(url, platform);
  
  // Performance monitoring
  const endTime = performance.now();
  if (endTime - startTime > 100) {
    console.warn(`Slow icon resolution: ${endTime - startTime}ms for ${url}`);
  }
  
  return platform;
}

// Get all platform categories
export function getPlatformCategories(): string[] {
  const categories = new Set<string>();
  Object.values(PLATFORM_ICONS).forEach(platform => {
    categories.add(platform.category);
  });
  return Array.from(categories).sort();
}

// Get platforms by category
export function getPlatformsByCategory(category: string): PlatformIconData[] {
  return Object.values(PLATFORM_ICONS).filter(
    platform => platform.category === category
  );
}

// Search platforms by name or alias
export function searchPlatforms(query: string): PlatformIconData[] {
  const searchTerm = query.toLowerCase();
  return Object.values(PLATFORM_ICONS).filter(platform => 
    platform.name.toLowerCase().includes(searchTerm) ||
    platform.id.includes(searchTerm) ||
    platform.aliases.some(alias => alias.includes(searchTerm))
  );
}

// Get total platform count
export function getPlatformCount(): number {
  return Object.keys(PLATFORM_ICONS).length - 1; // Exclude generic
}